// Who someone is in Production & Routing, from the features the platform granted them (`/api/me`):
// the Manager Role (GROUP_MANAGER) holds both features, the Warehouse Role (GROUP_WAREHOUSE) the
// routing one, and someone in the app's group but in neither holds none. The server decides
// (`backend/src/access.ts`); this only says it, for the header and for which pages render.

import { FEATURE_ROUTING, FEATURE_ROUTING_ADMIN, FEATURE_ROUTING_MANAGER } from "../reports";

export type RoutingRole = "Manager" | "Warehouse" | "No access";

/** The role the header shows: "Manager", "Warehouse" or "No access". */
export function routingRole(features: readonly { id: string }[] | undefined): RoutingRole {
  const ids = new Set((features ?? []).map((f) => f.id));
  if (ids.has(FEATURE_ROUTING_MANAGER)) return "Manager";
  if (ids.has(FEATURE_ROUTING)) return "Warehouse";
  return "No access";
}

/** The pages and Ask AI need the routing feature; without it they do not render at all. */
export const seesRoutingPages = (role: RoutingRole) => role !== "No access";

/** The $ value and managing the lists (the Carrier list too): the Manager Role only. */
export const managesLists = (role: RoutingRole) => role === "Manager";

/** The Admin page (division abbreviations): its own feature, the Manager Role's for now (`access.ts`). */
export const seesAdmin = (features: readonly { id: string }[] | undefined) =>
  (features ?? []).some((f) => f.id === FEATURE_ROUTING_ADMIN);
